import { useQuery } from '@tanstack/react-query';

import disputesClient, { DisputeResponse } from '@clients/disputesClient';
import { TransactionItem } from '@clients/transactionsClient';

const { getDisputeDetails } = disputesClient();

const useGetDisputeDetails = (
    transaction: TransactionItem,
    transactionId: number,
    onSuccess?: (data: DisputeResponse) => void,
) => {
    const { data, error, isError, isLoading, refetch } = useQuery(
        ['disputeDetails', transactionId],
        () =>
            getDisputeDetails({
                authorizationId: transaction?.authorization?.id,
            }),
        {
            onSuccess: onSuccess,
            // retry only once so that the report problem button becomes available sooner if it fails to find a dispute
            retry: 1,
            enabled: transaction?.authorization?.type === 'NETWORK',
        },
    );

    return { data, error, isError, isLoading, refetch };
};

export default useGetDisputeDetails;
